import { Ref, ref } from 'vue'

export const headerRef: Ref<HTMLElement | null> = ref(null)

export const headerDirectionMove = ref('top')